import { type } from '@mews/framework';
import ApiComponent from '../apiComponent';
import createRequest from './misc/createRequest';

const BASE_URL = '/services';

export default function ServiceComponent(apiComponent: $TSFixMe) {
    type.check(apiComponent, ApiComponent);
    const request = createRequest(apiComponent.request, BASE_URL);

    return type.create(ServiceComponent, {
        getAll({
            profileId,
            serviceIds,
            enterpriseId,
            enterpriseIds,
            serviceType,
            serviceDeletionState,
            extent,
        }: $TSFixMe) {
            return request('/getAll', {
                profileId,
                serviceIds,
                enterpriseId,
                enterpriseIds,
                serviceType,
                serviceDeletionState,
                extent,
            });
        },
        add({ enterpriseId, services }: $TSFixMe) {
            return request('/add', {
                enterpriseId,
                services,
            });
        },
        getAvailability({ serviceId, profileId, endUtc, startUtc, availabilityBlockId, extent }: $TSFixMe) {
            return request('/getAvailability', { serviceId, profileId, endUtc, startUtc, availabilityBlockId, extent });
        },

        getAvailabilities({ startUtc, endUtc, extent, serviceId }: $TSFixMe) {
            return request('/getAvailabilities', {
                firstTimeUnitStartUtc: startUtc,
                lastTimeUnitStartUtc: endUtc,
                extent,
                serviceId,
            });
        },

        getRatePricing({
            serviceId,
            profileId,
            startUtc,
            endUtc,
            purpose,
            businessSegmentId,
            voucherId,
            availabilityBlockId,
            partnerCompanyId,
            travelAgencyId,
            productIds,
            categoryOccupancies,
            extent,
            FrontendCorelationId,
        }: $TSFixMe) {
            return request('/getRatePricing', {
                serviceId,
                profileId,
                startUtc,
                endUtc,
                purpose,
                businessSegmentId,
                voucherId,
                availabilityBlockId,
                partnerCompanyId,
                travelAgencyId,
                productIds,
                categoryOccupancies,
                extent,
                FrontendCorelationId,
            });
        },

        getCustomerProfileStatistics(serviceId: $TSFixMe) {
            return request('/getCustomerStatistics', { serviceId });
        },

        getOccupancy({ startUtc, endUtc, serviceId }: $TSFixMe) {
            return request('/getOccupancy', {
                firstTimeUnitStartUtc: startUtc,
                lastTimeUnitStartUtc: endUtc,
                serviceId,
            });
        },

        getOverviewStatistics(serviceId: $TSFixMe) {
            return request('/getOverviewStatistics', { serviceId });
        },

        getOrderStatistics(enterpriseId: $TSFixMe, serviceId: $TSFixMe) {
            return request('/getOrderStatistics', { enterpriseId, serviceId });
        },

        updateAvailability({ serviceId, availabilityUpdates }: $TSFixMe) {
            return request('/updateAvailability', { serviceId, availabilityUpdates });
        },
    });
}
